var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_5632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45312 1.85167C2.67187 0.492298 4.45312 -0.210827 6.25781 -0.0702025C9.16406 0.164173 11.4609 2.53136 11.6016 5.43761C11.6719 6.77355 11.2734 8.08605 10.4766 9.14074L14.5312 12.7267C14.8125 12.9845 14.9766 13.336 15 13.711C15 14.086 14.8594 14.461 14.6016 14.7189C14.3437 14.9767 14.0156 15.0939 13.6406 15.0939C13.2422 15.0939 12.8672 14.9064 12.6094 14.6017L9.11719 10.4532C8.15625 11.1329 7.05469 11.4845 5.85937 11.4845H5.8125C2.88281 11.4845 0.398437 9.3048 0.0468742 6.39855C-0.164063 4.73449 0.351562 3.1173 1.45312 1.85167ZM0.398437 6.39855C0.726562 9.1173 3.04687 11.1564 5.8125 11.1564H5.85937C7.03125 11.1564 8.10937 10.7814 9.04687 10.0782L9.1875 9.98449L12.8672 14.3907C13.0547 14.6251 13.3359 14.7423 13.6406 14.7423C13.8984 14.7423 14.1562 14.6485 14.3437 14.461C14.5547 14.2735 14.6484 13.9923 14.6484 13.711C14.6484 13.4298 14.5312 13.172 14.2969 12.9845L10.0078 9.18761L10.1016 9.04699C10.8984 8.01574 11.2969 6.75011 11.25 5.43761C11.1328 2.69542 8.97656 0.46886 6.23437 0.257923C6.09375 0.257923 5.95312 0.234485 5.78906 0.234485C4.21875 0.234485 2.74219 0.914173 1.71094 2.06261C0.679686 3.28136 0.187499 4.8048 0.398437 6.39855Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78906 0.984375C8.39063 0.984375 10.5 3.09375 10.5 5.69531C10.5 8.29687 8.39063 10.4063 5.78906 10.4063C3.1875 10.4063 1.07812 8.29687 1.07812 5.69531C1.07812 3.09375 3.1875 0.984375 5.78906 0.984375ZM5.78906 10.0547C8.20313 10.0547 10.1484 8.08594 10.1484 5.69531C10.1719 3.28125 8.20313 1.33594 5.78906 1.33594C3.375 1.33594 1.42969 3.30469 1.42969 5.69531C1.42969 8.10937 3.39844 10.0547 5.78906 10.0547Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51562 4.92187L9.16406 4.99219C8.88281 3.60937 7.73437 2.50781 6.32812 2.29688L6.375 1.94531C7.94531 2.20313 9.1875 3.39844 9.51562 4.92187Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.399 12.1733L12.1504 12.4219L11.9018 12.1733L12.1504 11.9247L12.399 12.1733Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0386 12.8132L12.79 13.0618L12.5414 12.8132L12.79 12.5646L13.0386 12.8132Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6949 13.4689L13.4463 13.7175L13.1977 13.4689L13.4463 13.2203L13.6949 13.4689Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_5632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.199798e43f74a39629188ff85de3a108.svg";
export { ForwardRef as ReactComponent };